import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Storage } from '@wren/shared';

const { storage } = Storage;
const LAST_NON_CHECKOUT_PAGE_KEY = 'lastNonCheckoutPage';

/**
 * Hook to track and retrieve the last page visited that wasn't a checkout page.
 * This is useful for redirecting users back to where they came from when they
 * navigate away from checkout (e.g., when cart becomes empty).
 */
export default function useLastNonCheckoutPage() {
  const location = useLocation();

  // Track the current page if it's not a checkout page
  useEffect(() => {
    const pathname = location.pathname;

    // Only track pages that are not checkout pages
    if (!pathname.startsWith('/checkout')) {
      storage.set(LAST_NON_CHECKOUT_PAGE_KEY, pathname);
    }
  }, [location.pathname]);

  /**
   * Get the last non-checkout page, or return null if none exists
   */
  const getLastNonCheckoutPage = (): string | null => {
    const lastPage = storage.get(LAST_NON_CHECKOUT_PAGE_KEY);
    return lastPage || null;
  };

  /**
   * Clear the stored last non-checkout page
   */
  const clearLastNonCheckoutPage = () => {
    storage.remove(LAST_NON_CHECKOUT_PAGE_KEY);
  };

  return {
    getLastNonCheckoutPage,
    clearLastNonCheckoutPage,
  };
}
